<div mat-dialog-content>
  <events-sign-ups [groupId]="data.groupId" [eventId]="data.eventId">
  </events-sign-ups>
</div>
